import { track } from '@bnnvara/analytics/src/track';
import { Bookmark as BookmarkIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Bookmark';
import PropTypes from 'prop-types';
import React from 'react';
import { useBrand } from '@bnnvara/brand';

import { useIsBookmarkedByUser } from '../useIsBookmarkedByUser';
import * as S from './styled';

export function Bookmark({ content, size, textColor }) {
  const brand = useBrand();
  const { isBookmarkedByUser, toggle } = useIsBookmarkedByUser(
    content,
    brand?.id
  );

  const label = isBookmarkedByUser ? 'bewaard!' : 'bewaren';

  async function handleClick() {
    const result = await toggle();

    if (result === true) {
      track('article', 'click', 'bookmark');
    } else if (result === false) {
      track('article', 'click', 'verwijder bookmark');
    }
  }

  return (
    <S.Button
      aria-label="bewaar of verwijderd bewaarde publicatie"
      onClick={handleClick}
      isBookmarked={isBookmarkedByUser}
      size={size}
    >
      <BookmarkIcon
        state={isBookmarkedByUser ? 'active' : 'normal'}
        size={size}
      />
      <S.Text color={textColor} size={size}>
        {label}
      </S.Text>
    </S.Button>
  );
}

Bookmark.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    publishDate: PropTypes.string,
    href: PropTypes.string,
    commentCount: PropTypes.number,
    image: PropTypes.shape({
      url: PropTypes.string,
      altText: PropTypes.string,
    }),
  }),

  size: PropTypes.string,
  textColor: PropTypes.string,
};

Bookmark.defaultProps = {
  size: 'm',
  textColor: 'black',
};
